import { Download, Loader2 } from 'lucide-react';

/**
 * Téléchargement facture / avoirs émis — affichage conditionnel (iPad POS).
 */
export default function CaisseCommandeFactureAvoirActions({
  commandeId,
  numeroFacture,
  avoirs,
  factureAvailable,
  factureLoading,
  onDownloadFacture,
  onDownloadAvoir,
  avoirLoadingId,
  formatMoney,
  testIdPrefix = 'caisse-docs',
}) {
  const list = Array.isArray(avoirs) ? avoirs : [];
  const showFacture = factureAvailable && typeof onDownloadFacture === 'function';
  if (!showFacture && list.length === 0) {
    return null;
  }

  return (
    <div className="space-y-2" data-testid={`${testIdPrefix}-facture-avoir-block`}>
      {showFacture && (
        <button
          type="button"
          onClick={onDownloadFacture}
          disabled={factureLoading || !commandeId}
          className="w-full min-h-[52px] py-3 px-4 rounded-xl bg-violet-700 text-white font-semibold hover:bg-violet-800 disabled:opacity-50 flex items-center justify-center gap-2"
          data-testid={`${testIdPrefix}-facture-download`}
        >
          {factureLoading ? (
            <Loader2 className="h-5 w-5 animate-spin" aria-hidden />
          ) : (
            <Download className="h-5 w-5" aria-hidden />
          )}
          {numeroFacture ? `Facture ${numeroFacture}` : 'Télécharger la facture'}
        </button>
      )}
      {list.map((av) => (
        <button
          key={av.id}
          type="button"
          onClick={() => onDownloadAvoir?.(av.id)}
          disabled={!commandeId || avoirLoadingId === av.id}
          className="w-full min-h-[52px] py-3 px-4 rounded-xl bg-slate-700 text-white font-semibold hover:bg-slate-800 disabled:opacity-50 flex items-center justify-between gap-3"
          data-testid={`${testIdPrefix}-avoir-${av.id}`}
        >
          <span className="flex items-center gap-2 min-w-0 truncate">
            {avoirLoadingId === av.id ? (
              <Loader2 className="h-5 w-5 shrink-0 animate-spin" aria-hidden />
            ) : (
              <Download className="h-5 w-5 shrink-0" aria-hidden />
            )}
            <span className="truncate">Avoir {av.numeroAvoir}</span>
          </span>
          <span className="tabular-nums shrink-0">
            −{formatMoney(Number(av.montantTTC || 0))}
          </span>
        </button>
      ))}
    </div>
  );
}
